export const colours = {
	white: "#FDFDFD",
	black: "#434344",
	red: "#D52729",
	redDark: "#c91c1f",
	yellow: "#E4AE0E",
	yellowLight: "#FFBF00",
	green: "#148003",
	greyDarker: "#667179",
	greyDark: "#DEDEDE",
	greyLight: "#F6F6F6",
	greyMedium: "#E2E2E2",
	blueGrey: "#252D33",
};
